import React, { Component } from 'react';
import './Card.css';

export default class Card extends Component {
	render() {
		return <div className={'g-card ' + (this.props.className || '')}>{this.props.children}</div>;
	}
}
